/*eslint no-console: 0*/

import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {safeJSONparse} from '../../common/util/safeJSONparse';
import {variableResolver} from '../../common/util/VariableResolver';
import {injectIntl, IntlShape} from 'react-intl';
import types from "../../common/model-api/types";
import * as Tool from '../fw/Tool';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import config from '../../common/config';
import { Flow, User } from '../../common/types/types';

interface AppliedFlowDescriptionProps {
 flow: Flow;
 intl?: object;
 user: User;
}

class AppliedFlowDescription extends React.Component<AppliedFlowDescriptionProps> {
    static propTypes = {
        flow: PropTypes.object.isRequired,
        intl: PropTypes.object,
        user: PropTypes.object.isRequired,
    };

    render() {
        let flow = this.props.flow;

        let options = {...safeJSONparse(flow.options)};
        options['dativeryEmail'] = this.props.user.email;
        options['serviceUrl'] = 'https://' + window.location.hostname + '/api/v1/hooks/flow/' + encodeURIComponent(flow.realId) + '/' + encodeURIComponent(flow.secret) + '';
        options['serviceHookProxyUrl'] = config.PUBLIC_HOOK_PROXY_URL + '/' + config.STAGE + '/api/v1/hooks/flow/' + encodeURIComponent(flow.realId) + '/' + encodeURIComponent(flow.secret) + '';
        options['serviceKey'] = encodeURIComponent(flow.realId) + '/' + encodeURIComponent(flow.secret) + '';

        console.log("OPTIONS", options);

        let selectedChannels = safeJSONparse(flow.selectedChannels);
        for (let key of Object.keys(selectedChannels)) {
            let res = flow.myChannels.edges.find(({node}) => node.realId === selectedChannels[key]);

            if (res) {
                let channel = res.node;

                if (channel && channel.channelDef) {
                    options[key] = channel.channelDef.name;
                } else {
                    options[key] = '';
                }
            } else {
                options[key] = '';
            }
        }

        if (options) {
            Object.keys(options).map((key) => {
                let value = options[key];
                if (value && typeof value === 'object') {
                    Object.keys(options[key]).map((key2) => {
                        let newKey = key + "-" + key2;
                        let newKey2 = newKey.replace(/-/g, '_');
                        options[newKey] = options[key][key2];
                        options[newKey2] = options[key][key2];
                    });
                }
            });
        }

        let appliedDescription = Tool.getFormatted(types['flowDefs'], 'appliedDescription', this.props.intl.formatMessage, {appliedDescription: variableResolver(flow.appliedDescription || flow.flowDef.appliedDescription, options, true)});

        return appliedDescription;
    }
}

export default Relay.createContainer(injectIntl(AppliedFlowDescription), {
    initialVariables: {
        organisationId: '',
        flowId: '',
    },
    prepareVariables (variables) {
        if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }

        return variables;
    },
    fragments: {
        flow: () => Relay.QL`
            fragment on Flow {
                id,
                realId,
                organisation_id,
                options,
                secret,
                selectedChannels,
                appliedDescription,
                myChannels: channels(first: 100) {
                    edges {
                        node {
                            id,
                            realId,
                            name,
                            organisation_id,
                            channelDef_id,
                            channelDef {
                                id,
                                realId,
                                name,
                                icon,
                                state
                            }
                        }
                    }
                },
                flowDef {
                    id,
                    realId,
                    name,
                    appliedDescription,
                }
            }
        `,
        user: () => Relay.QL`
            fragment on User {
                id,
                realId,
                email,
            }
        `,

    },
});
